import { defineStore } from 'pinia';
import { ref } from 'vue';
import { IBrowserNotificationPayload } from '@/interfaces/powerMarkets/notifications/IBrowserNotificationPayload.ts';

const useDataHubStore = defineStore('dataHubStore', () => {
    const lastHeartbeat = ref<string>('');
    const globalNotification = ref<string>('');
    const nonBmStorUpdate = ref<string>('');
    const browserNotifications = ref<Array<IBrowserNotificationPayload>>([]);

    function pushBrowserNotification (payload: IBrowserNotificationPayload): void {
        browserNotifications.value = [...browserNotifications.value, payload];
    }

    return {
        lastHeartbeat,
        globalNotification,
        nonBmStorUpdate,
        browserNotifications,
        pushBrowserNotification,
    };
});

export {
    useDataHubStore,
};
